export default "__VITE_ASSET__BGC_$_kk__"